/**
 * AJUSTE ESTE ARQUIVO conforme seu layout de carrinho.
 * Ele lida com alterações de quantidade, aplicação de cupom,
 * remoção de itens e re-renderização do resumo do carrinho.
 */

window.AjaxCart = (function() {
  
  // ==============================
  // Variáveis de seletores
  // ==============================
  const cartFormSelector         = '[data-cart-content]';           // O <form> principal do carrinho
  const cartItemsContainer       = '[data-cart-items]';             // Container dos itens do carrinho
  const cartSubtotalSelector     = '.t4s-cart__totalPrice';         // Subtotal textual
  const discountInputSelector    = '#CartDiscountcode';             // Input do cupom
  const discountApplyButtonSel   = '.apply-btn';                    // Botão que aplica cupom
  const couponMessageSel         = '#coupon-message';               // Mensagem de erro/sucesso do cupom

  // Exemplo de endpoint do Shopify p/ "alterar carrinho"
  const cartChangeEndpoint = '/cart/change.js';
  // Exemplo de endpoint para GET do carrinho completo
  const cartJsonEndpoint   = '/cart.js';

  // ==============================
  // Função para formatar dinheiro
  // ==============================
  function formatMoney(cents) {
    // Ajuste se quiser outro formato, ou use o `Shopify.formatMoney`
    // se estiver disponível
    const price = (cents / 100).toFixed(2);
    // Ex: R$ 10,00
    return `R$ ${price.replace('.', ',')}`;
  }

  // ==============================
  // Chamada fetch p/ obter carrinho completo (cart.js)
  // ==============================
  function getCartState() {
    return fetch(cartJsonEndpoint, { method: 'GET' })
      .then(res => res.json())
      .catch(err => {
        console.error('Erro ao obter carrinho:', err);
      });
  }

  // ==============================
  // Renderizar novamente os itens do carrinho
  // (substituir HTML do container ou parcial)
  // ==============================
  function reRenderCartHTML(htmlContent) {
    // Exemplo: Substituir o container .t4s-cartPage__items
    // com um HTML parcial que vem do servidor.
    // (Se você tiver um snippet Liquid no backend que retorna
    //  apenas o pedaço do carrinho, pode usar).
    // 
    // Caso não tenha snippet pronto, use getCartState() e
    // re-renderize manualmente por JS. Abaixo, iremos supor
    // que você possui um endpoint /cart?view=ajax 
    // que retorna HTML parcial do carrinho.
    const cartItemsEl = document.querySelector(cartItemsContainer);
    if (cartItemsEl) {
      cartItemsEl.innerHTML = htmlContent;
    }
  }

  // ==============================
  // Buscar HTML parcial do carrinho e atualizar
  // ==============================
  function refreshCartHtml() {
    // Se seu tema possuir snippet, algo como:
    // /cart?view=ajax => retorna HTML do .t4s-cartPage__items
    const partialUrl = '/cart?view=ajax';

    fetch(partialUrl)
      .then(response => response.text())
      .then(html => {
        // Substitui apenas o container de itens
        reRenderCartHTML(html);

        // OU se quiser recarregar também o subtotal,
        // podemos extrair do HTML da partial:
        //   let parser = new DOMParser();
        //   let doc = parser.parseFromString(html, 'text/html');
        //   let newSubtotal = doc.querySelector('.t4s-cart__totalPrice').textContent;
        //   document.querySelector('.t4s-cart__totalPrice').textContent = newSubtotal;

        attachQuantityHandlers(); // re-adiciona eventos
        attachRemoveItemHandlers();
      })
      .catch(err => console.error('Erro ao buscar partial do carrinho', err));
  }

  // ==============================
  // Mudar quantidade de item
  // ==============================
  function updateItemQuantity(line, newQty) {
    // line => 1-based index do item no carrinho
    // /cart/change.js => line= X, quantity= Y
    const bodyData = { line: line, quantity: newQty };

    return fetch(cartChangeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData),
    })
      .then(res => res.json())
      .then(data => {
        refreshCartHtml(); // re-render HTML
      })
      .catch(err => console.error('Erro ao alterar qty:', err));
  }

  // ==============================
  // Lógica p/ remover item do carrinho
  // ==============================
  function removeItem(line) {
    // Basta setar quantity=0
    updateItemQuantity(line, 0);
  }

  // ==============================
  // Handlers p/ increment/decrement
  // ==============================
  function attachQuantityHandlers() {
    // Exemplo de botões .increment / .decrement
    const incrementBtns = document.querySelectorAll('[data-increment]');
    const decrementBtns = document.querySelectorAll('[data-decrement]');

    incrementBtns.forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const line = btn.getAttribute('data-line'); // ou data-line
        const input = document.querySelector(`[data-quantity-input="${line}"]`);
        if (!input) return;

        let val = parseInt(input.value, 10) || 1;
        val++;
        updateItemQuantity(line, val);
      });
    });

    decrementBtns.forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const line = btn.getAttribute('data-line');
        const input = document.querySelector(`[data-quantity-input="${line}"]`);
        if (!input) return;

        let val = parseInt(input.value, 10) || 1;
        val = Math.max(val - 1, 1);
        updateItemQuantity(line, val);
      });
    });

    // inputs de digitar a quantity
    const qtyInputs = document.querySelectorAll('[data-quantity-input]');
    qtyInputs.forEach(input => {
      input.addEventListener('change', (ev) => {
        const line = input.getAttribute('data-quantity-input');
        let val = parseInt(input.value, 10) || 1;
        if (val < 1) val = 1;
        updateItemQuantity(line, val);
      });
    });
  }

  // ==============================
  // Lógica p/ remover item
  // ==============================
  function attachRemoveItemHandlers() {
    const removeBtns = document.querySelectorAll('[data-remove-line]');
    removeBtns.forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const line = btn.getAttribute('data-remove-line');
        removeItem(line);
      });
    });
  }

  // ==============================
  // Handler p/ Cupom
  // ==============================
  function applyDiscountCode(code) {
    // Adiciona "?discount=CODE" na URL do carrinho:
    const discountUrl = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
    // ou método "updateAttribute" etc.

    // Exemplo 1 => usar window.location:
    // window.location = discountUrl;

    // Exemplo 2 => tentar AJAX e depois reRender. 
    // (Mas, via Shopify, é comum redirect)
    window.location.href = discountUrl;
  }

  // ==============================
  // Focar no <input> + click no "apply" => aciona
  // ==============================
  function attachDiscountCodeHandler() {
    const applyBtn = document.querySelector(discountApplyButtonSel);
    const codeInput = document.querySelector(discountInputSelector);
    if (!applyBtn || !codeInput) return;

    applyBtn.addEventListener('click', (ev) => {
      ev.preventDefault();
      const code = codeInput.value.trim();
      if (!code) {
        const messageEl = document.querySelector(couponMessageSel);
        if (messageEl) messageEl.textContent = 'Por favor, insira um código.';
        return;
      }
      applyDiscountCode(code);
    });
  }

  // ==============================
  // Inicializar
  // ==============================
  function init() {
    console.log('AjaxCart init...');
    // Anexa handlers
    attachQuantityHandlers();
    attachRemoveItemHandlers();
    attachDiscountCodeHandler();
    // Se quiser, poderia atualizar 1x o cart:
    // refreshCartHtml();
  }

  // Retorna API
  return {
    init,
    refreshCartHtml
  };

})();

// Ao carregar este script, chamamos init():
document.addEventListener('DOMContentLoaded', () => {
  if (window.AjaxCart) {
    window.AjaxCart.init();
  }
});


